// Escapes the `/` separators of a resource name (e.g. flags/my-flag) so it
// can be used as a field or value inside a filter expression.
export const escapeResourceName = (name: string): string =>
  name.replaceAll('/', '\\/');

export const escapeQuery = (value: unknown): string => {
  if (typeof value !== 'string') return '';

  return value
    .replace(/[<>]/g, ``)
    .replace(/([+=&|><!(){}[\]^"~*?:\\/])/g, '\\$1');
};

export const unwrapQueryParamString = (
  value: string | string[] | null | undefined,
): string | null => {
  if (value === null || value === undefined) return null;

  if (Array.isArray(value)) {
    if (value.length === 0) return null;
    const first = value[0];
    return first === undefined ? null : first;
  }

  return value;
};

export const unwrapQueryParamNumber = (
  value: number | string | string[] | null | undefined,
): number | null => {
  if (value === null || value === undefined) return null;
  if (typeof value === 'number') {
    return Number.isNaN(value) ? null : value;
  }

  const str = unwrapQueryParamString(value);
  if (str === null || str === '') return null;

  const n = Number(str);
  return Number.isNaN(n) ? null : n;
};

// epx-metrics scopes metric, fact table, assignment table, dimension table and
// exposure table lists to the account's primary data warehouse unless the
// filter names one. Naming it is therefore the only way to reach resources in
// any other warehouse. Entities are not warehouse-scoped and must not use this.
export const dataWarehouseFilter = (dataWarehouseName?: string): string =>
  dataWarehouseName ? `dataWarehouse:"${dataWarehouseName}"` : '';

export const stripProtocol = (value: string): string =>
  value.replace(/^https?:\/\//i, '');

export const buildSearchFilter = (
  query: string,
  fields: string | string[],
): string | undefined => {
  if (!query) return undefined;
  const escaped = escapeQuery(query);
  const quoted = query.replace(/[<>]/g, '').replace(/[\\"]/g, '\\$&');
  const fieldList = Array.isArray(fields) ? fields : [fields];
  const conditions = fieldList.flatMap(field => [
    `${field}:*${escaped}*`,
    `${field}:"${quoted}"`,
  ]);
  return `(${conditions.join(' OR ')})`;
};
